import { IonSkeletonText } from '@ionic/react'
import { Link } from 'react-router-dom'

import { useMyCallLists } from '../../../hooks/outreach/queries'
import { Card, CardTitle, CardContent, CardHeader } from '../../ui/card'
import ScrollingList from '../../ui/scrolling-list'
import { SectionContent, SectionHeader, SectionWrapper } from '../section'

import type { CallList } from '../../../hooks/outreach/queries'

function ManagerListCard({ callList }: { callList: CallList }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{callList.name}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex h-full flex-1 flex-col">
          <p className="mt-auto pt-2 text-center text-sm leading-none">
            {callList.stats.clientCount} Client
            {callList.stats.clientCount === 1 ? '' : 's'}
          </p>
        </div>
      </CardContent>
    </Card>
  )
}

function ManagerListSkeleton() {
  return (
    <div className="ml-3 flex">
      {Array(10)
        .fill(null)
        .map((_i, idx) => (
          <div key={idx} className="mr-3 w-36">
            <Card>
              <CardHeader>
                <CardTitle>
                  <IonSkeletonText
                    animated
                    style={{
                      '--background': 'rgba(0,0,0,.65)',
                      '--background-rgb': '0,0,0',
                    }}
                    className="size-full m-0"
                  />
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p className="mx-auto mt-auto w-2/5 pt-2 text-center text-sm leading-none">
                  <IonSkeletonText
                    animated
                    style={{
                      '--background': 'rgba(0,0,0,.65)',
                      '--background-rgb': '0,0,0',
                    }}
                    className="size-full m-0"
                  ></IonSkeletonText>
                </p>
              </CardContent>
            </Card>
          </div>
        ))}
    </div>
  )
}

function ManagersListSection() {
  const callListsQuery = useMyCallLists()

  return (
    <>
      {callListsQuery.data ? (
        <>
          {Boolean(callListsQuery.data.length) ? (
            <SectionWrapper>
              <SectionHeader title="Manager's Lists" />
              <SectionContent>
                <ScrollingList>
                  {callListsQuery.data.map((callList) => (
                    <Link
                      key={callList.objectId}
                      to={`/tabs/clients/outreach/${callList.objectId}`}
                      className="flex w-36"
                    >
                      <ManagerListCard
                        key={callList.objectId}
                        callList={callList}
                      />
                    </Link>
                  ))}
                </ScrollingList>
              </SectionContent>
            </SectionWrapper>
          ) : null}
        </>
      ) : (
        <ManagerListSkeleton />
      )}
    </>
  )
}

export default ManagersListSection
